<template lang="pug">
	b-card.custom-overlay-card(:img-src='_post.image||imgDefault' :img-alt='_post.title' text-variant='white')
		b-card-title.text-overflow-4(style="margin-top:6rem;")
			router-link(:to="`/${_baseUrl}/${_post.id}`" style="color: inherit;") {{ _post.title }}
		b-card-text.text-overflow-5(v-html="_post.short") {{ _post.short }}
		b-card-text.mt-2
			.badge-list
				b-badge.badge-list__badge(variant="light" href="#" v-for="tag in _post.tag" :key="tag.id") {{ tag.title }}
		b-card-text.d-flex.justify-content-between
			router-link(:to="`/${_baseUrl}/${_post.id}`" style="color: inherit;") Подробнее

</template>

<script>
	export default {
		name: 'ResourceCard',
		props: ['_post','_baseUrl'],
		data: () => ({
			imgDefault: '/img/img-news-default.png',
		}),
	}
</script>
